import { useState } from 'react';
import { Button, useUpdate } from 'react-admin';
import { MergeType } from '@mui/icons-material';
import { dataProvider } from '../../firebase';
import { ISession } from '../../types';
import { getSessionsForSpeaker } from './utils';

export interface IMergeSpeakersButtonProps {
  selectedIds: string[];
}

const MergeSpeakersButton = (props: IMergeSpeakersButtonProps) => {
  const { selectedIds } = props;
  const [update] = useUpdate();
  const [wip, setWIP] = useState(false);

  const baseSpkId = selectedIds[0];
  const spkIdsToDelete = selectedIds.slice(1);

  const doMerge = async () => {
    setWIP(true);
    const sessions = (
      await dataProvider.getList('sessions', {
        pagination: { page: 1, perPage: 1000000 },
        sort: { field: 'id', order: 'DESC' },
        filter: {},
      })
    ).data as ISession[];
    let sessionsToUpdate = [] as ISession[];
    selectedIds.forEach((sid: string) => {
      const sesForSpk = getSessionsForSpeaker(sid, sessions);
      sessionsToUpdate = sessionsToUpdate.concat(sesForSpk);
    });

    sessionsToUpdate.forEach((ses: ISession) => {
      ses.speakersId = ses.speakersId.filter((sid: string) => !selectedIds.includes(sid));
      ses.speakersId.push(baseSpkId);
    });

    const proms = sessionsToUpdate.map((sud: ISession) => update('sessions', { id: sud.id, data: sud, previousData: sud }));
    await Promise.all(proms);

    await dataProvider.deleteMany('speakers', { ids: spkIdsToDelete });

    setWIP(false);
    window.location.reload();
  };

  return (
    <Button label="Mergear 2 (o mas) speakers" disabled={wip} onClick={doMerge}>
      <MergeType />
    </Button>
  );
};

export default MergeSpeakersButton;
